// Dependencies
import React from "react";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";

// Material UI Components
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

import Select from "components/selects/Select/Select.component";

import {
  replaceQueryItem,
  replaceSlugAndQuery,
} from "helpers/inventory-filters";

// Styles
import { useStyles } from "./InventorySortDropdown.styles";

const InventorySortDropdown = ({ dataCy, clearInventoryCards }) => {
  const router = useRouter();
  const { sortBy } = router.query;
  const desktopView = useSelector((state) => state.global.desktopView);
  const MenuComponent = desktopView ? MenuItem : "option";
  const classes = useStyles();
  const dropdownOptions = [
    { key: "option-rank-desc", text: "Default", value: "rank desc" },
    {
      key: "option-price-desc",
      text: "Price: high to low",
      value: "price desc",
    },
    { key: "option-price-asc", text: "Price: low to high", value: "price asc" },
    {
      key: "option-kilometers-desc",
      text: "Kilometers: high to low",
      value: "kilometers desc",
    },
    {
      key: "option-kilometers-asc",
      text: "Kilometers: low to high",
      value: "kilometers asc",
    },
    {
      key: "option-year-desc",
      text: "Year: newest to oldest",
      value: "year desc",
    },
    {
      key: "option-year-asc",
      text: "Year: oldest to newest",
      value: "year asc",
    },
  ];

  return (
    <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
      <Select
        className={classes.customSelect}
        data-cy={dataCy}
        native={!desktopView}
        displayEmpty
        value={sortBy || ""}
        onChange={(event) => {
          clearInventoryCards();
          const newQuery = replaceQueryItem(router.query, {
            key: "sortBy",
            value: event.target.value,
          });
          replaceSlugAndQuery(router, router.query.slug, newQuery);
        }}
        SelectDisplayProps={{ className: classes.button }}
        inputProps={{
          name: "inventory-sort-type",
          id: "inventory-sort-type",
        }}
      >
        <MenuComponent disabled value="">
          Sort by
        </MenuComponent>
        {dropdownOptions.map((option) => (
          <MenuComponent
            key={`sortOption-${option.text}`}
            aria-label={option.text}
            value={option.value}
            selected
            classes={{ selected: classes.selected }}
          >
            {option.text}
          </MenuComponent>
        ))}
      </Select>
    </FormControl>
  );
};

InventorySortDropdown.propTypes = {};

InventorySortDropdown.defaultProps = {};

export default InventorySortDropdown;
